import React from 'react'
import KmlLayer from "google-map-react";
//import { useGlifosPlayerData, useGlifosPlayerUpdate } from 'modules/glifos-rich-media/components/GlifosRichMediaProvider/GlifosRichMediaProvider';
import styles from './MapItext.module.scss';
import ApiURLs from 'services/BackendApi/BackendApiURLs';
import GoogleMapReact from "google-map-react";
import { GeoAltFill } from 'react-bootstrap-icons';
import mark from 'assets/img/tpmblank.png';

const containerStyle = {
    width: '100%',
    height: '100%'
};

const AnyReactComponent = ({ text }) => (
    <div >
        {/* {mark} */}
        <img src={mark} />
    </div>
);

/* const options = {
    zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER // 'right-center' ,
        // ...otherOptions
    }
} */

export default function MapItext(props) {
    /* const playerData = useGlifosPlayerData();
    const playerUpdate = useGlifosPlayerUpdate(); */
    const [kmlLayer, setKmlLayer] = React.useState(null);

    const { item } = props;
    //console.log('item', item);
    const options = {
        center: {
            lat: parseFloat(item.latitud),
            lng: parseFloat(item.longitud)
        },
        zoom: item.zoom
    };

    /* const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
    }) */

    const [map, setMap] = React.useState(null)

    const onGoogleApiLoaded = ({ map, maps }) => {
        // Load the KML layer
        const kml = new maps.KmlLayer({
            url: ApiURLs.baseURL + '/glifos/glifos/file/get/' + item.id_file
        });
        kml.setMap(map);

        // Set the kmlLayer state variable
        setKmlLayer(kml);
    };

    // Return map bounds based on list of places
    const getMapBounds = (map, maps) => {
        const bounds = new maps.LatLngBounds();
        return bounds;
    };

    // Re-center map when resizing the window
    const bindResizeListener = (map, maps, bounds) => {
        maps.event.addDomListenerOnce(map, 'idle', () => {
            maps.event.addDomListener(window, 'resize', () => {
                map.fitBounds(bounds);
            });
        });
    };

    // Fit map to its bounds after the api is loaded
    const apiIsLoaded = (map, maps) => {
        // Get bounds by our places
        const bounds = getMapBounds(map, maps);
        // Fit map to bounds
        map.fitBounds(bounds);
        // Bind the resize listener
        //bindResizeListener(map, maps, bounds);
    };


    /* 
    onMouseEnter={() => {
            if (playerData.markTime === null) {
                playerUpdate.update({ markTime: { start: timeToSeconds("00:30"), end: timeToSeconds("01:00") } });
            } else { playerUpdate.update({ markTime: null }); }
        }}
        onMouseLeave={() => { playerUpdate.update({ markTime: null }); }}
    */

    /* return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={options.center}
            zoom={options.zoom}
            onLoad={onLoad}
            onUnmount={onUnmount}
        >
            
            
            {/* {
                item.map((location, index) => {
                    return (
                        <Marker
                            className={`${styles.marker}`}
                            key={index}
                            position={{ lat: location.lat, lng: location.lng }}
                            onClick={() => playerUpdate.command({ type: "seek", value: "00:30" })}
                            onMouseOver={() => {
                                if (playerData.markTime === null) {
                                    playerUpdate.update({ markTime: { start: timeToSeconds("00:30"), end: timeToSeconds("01:00") } });
                                } else { playerUpdate.update({ markTime: null }); }
                            }}
                            onMouseOut={() => { playerUpdate.update({ markTime: null }); }}

                        />
                    )
                })
            }  
        </GoogleMap>
    ) : <></> */

    //console.log("kml", kmlLayer);

    return (
        <div className="App" style={{ width: "100%", height: "100%" }}>
            {item?.longitud && (
                <GoogleMapReact
                    bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
                    defaultCenter={options.center}
                    defaultZoom={options.zoom}
                    yesIWantToUseGoogleMapApiInternals
                    /* onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)} */
                >
                    <></>
                    {/* {kmlLayer && <KmlLayer layer={kmlLayer} />} */}
                    {/* <AnyReactComponent
                    lat={59.955413}
                    lng={30.337844}
                    text="My Marker"
                /> */}
                    {/* {item.coordinates.map((location, index) => {
                    return (
                        <AnyReactComponent
                            lat={location.lat}
                            lng={location.lng}
                            text="My Marker"
                        />
                    )
                })} */}

                </GoogleMapReact>
            )}
        </div>
    );

}

